class RecentlyViewed extends HTMLElement {
    constructor() {
      super();
    }
  
    connectedCallback() {
        try {
            this.productHandle = this.dataset.productHandle;
            this.productsToShow = this.dataset.limit;
            this.sectionId = this.dataset.sectionId;
    
            this.recentlyViewedPdpLocalStorageKey = 'recently_viewedPDP';
            this.recentlyViewedPdpData = this.getRecentlyViewedPdpData();

            if (this.recentlyViewedPdpData.length == 0) {
                document.querySelector('.separator--dot ').style.display = 'none';
            } else if (this.recentlyViewedPdpData.length > 0 && !this.productHandle) {
                this.productHandle = this.recentlyViewedPdpData[0].handle;
            }
    
            this.storeCurrentPdpView();
            this.loadRecentlyViewedProducts();
        } catch (e) {
            console.error('Error ' + e);
        }
    }
  
    /**
     * @returns array
     * @throws Error
     * */
    getRecentlyViewedPdpData() {
        if (typeof this.recentlyViewedPdpLocalStorageKey === 'undefined' || this.recentlyViewedPdpLocalStorageKey.trim() === '') {
            throw new Error('while getting recently viewed products: key is missing');
        }
    
        if (localStorage.getItem(this.recentlyViewedPdpLocalStorageKey) === null) {
            return [];
        }
    
        try {
            const recentlyViewedPdpData = JSON.parse(localStorage.getItem(this.recentlyViewedPdpLocalStorageKey));
    
            if (recentlyViewedPdpData.some(product => (typeof product.handle !== 'undefined' && product.handle !== ''))) {
                return recentlyViewedPdpData;
            }
        } catch {
        }
  
        console.warn('Recently viewed products are invalid');
        this.clearRecentlyViewedPdpData();
        return [];
    }
  
    /** @var recentlyViewedPdpData array */
    setRecentlyViewedPdpData(recentlyViewedPdpData) {
        if (typeof this.recentlyViewedPdpLocalStorageKey === 'undefined' || this.recentlyViewedPdpLocalStorageKey.trim() === '') {
            throw new Error('while setting recently viewed products: key is missing');
        }
    
        localStorage.setItem(this.recentlyViewedPdpLocalStorageKey, JSON.stringify(recentlyViewedPdpData));
    }
  
    clearRecentlyViewedPdpData() {
        if (typeof this.recentlyViewedPdpLocalStorageKey === 'undefined' || this.recentlyViewedPdpLocalStorageKey.trim() === '') {
            throw new Error('while clearing recently viewed products: key is missing');
        }
    
        localStorage.removeItem(this.recentlyViewedPdpLocalStorageKey);
        console.info('Recently viewed products cleared');
    }
  
    /** @throws Error */
    loadRecentlyViewedProducts() {
        if (typeof this.productHandle === 'undefined' || this.productHandle.trim() === '') {
            throw new Error('while loading recently viewed products: product handle is missing');
        }
    
        if (typeof this.productsToShow === 'undefined' || this.productsToShow.trim() === '' || this.productsToShow == 0) {
            throw new Error('while loading recently viewed products: products to show is missing');
        }
    
        if (typeof this.sectionId === 'undefined' || this.sectionId.trim() === '') {
            throw new Error('while loading recently viewed products: section id is missing');
        }
    
        if (this.recentlyViewedPdpData.length === 0) {
            return;
        }
    
        const handleIntersection = (entries, observer) => {
            if (! entries[0].isIntersecting) return;
            observer.unobserve(this);
    
            const productsHandles = [];
            this.recentlyViewedPdpData.forEach(product => (typeof product.handle !== 'undefined' && product.handle !== this.productHandle && productsHandles.push(product.handle)));
            if (productsHandles.length === 0) {
            return;
            }
    
            fetch(
                window.routes.root_url + '?section_id=' + this.sectionId + '&handles=' + productsHandles.join(','),
                {
                    cache: "no-cache"
                }
            )
            .then((response) => response.text())
            .then((text) => {
                const html = document.createElement('div');
                html.innerHTML = text;
        
                const recentlyViewed = html.querySelector('recently-viewed');
        
                if (recentlyViewed && recentlyViewed.innerHTML.trim().length) {
                    this.innerHTML = recentlyViewed.innerHTML;
                }
            }).catch(function (error) {
                console.error('while displaying recently viewed products: ' + error);
            });
        }
    
        new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
        this.style.display = 'block';
    }
  
    /** @throws Error */
    storeCurrentPdpView() {
        if (typeof this.productHandle === 'undefined' || this.productHandle.trim() === '') {
            throw new Error('while storing current PDP view: product handle is missing');
        }

        const index = this.recentlyViewedPdpData.findIndex(product => product.handle === this.productHandle);

        if (index !== -1) {
            this.recentlyViewedPdpData.splice(index, 1);
        }
    
        if (this.recentlyViewedPdpData.length > this.productsToShow) {
            this.recentlyViewedPdpData = this.recentlyViewedPdpData.slice(this.productsToShow * -1);
        }
    
        this.recentlyViewedPdpData.push({
            handle: this.productHandle
        });
    
        this.setRecentlyViewedPdpData(this.recentlyViewedPdpData);
    }
  }
  
customElements.define('recently-viewed', RecentlyViewed);